import * as angular from 'angular';

import { ApplicationUserViewModel, ComponentDefinition } from '../../models';

class UserPictureController implements angular.IComponentController {
    readonly placement: string;
    readonly showPopover: boolean = false;
    readonly user: ApplicationUserViewModel;
    
    static $inject = [];
}

export const wtUserPicture: ComponentDefinition = {
    componentId: 'wtUserPicture',
    controller: UserPictureController,
    template: require('./userPicture.component.html'),
    controllerAs: 'vm',
    bindings: {
        placement: '@?',
        showPopover: '<?',
        user: '<',
    }
};